import React, { FC } from 'react';
import styled from 'styled-components/native';

import dynamicSize from '@webtrader/core/dynamic-size';
import { useTranslation } from '@webtrader/core/i18n';

import Button from '@/components/Button';

interface IFormActionsProps {
  isSubmitting: boolean;
  onSubmit: () => void;
  isDisabled?: boolean;
}

const FormActions: FC<IFormActionsProps> = ({ isSubmitting, onSubmit, isDisabled }) => {
  const { t } = useTranslation();

  return (
    <StyledButtonWrapper>
      <Button disabled={isSubmitting || isDisabled} loading={isSubmitting} onPress={onSubmit}>
        {isSubmitting ? `${t('SUBMITTING')}...` : t('SUBMIT')}
      </Button>
    </StyledButtonWrapper>
  );
};

export default FormActions;

const StyledButtonWrapper = styled.View`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: ${dynamicSize.convertSize(24)}px;
`;
